import script from "./NkSelect.vue?vue&type=script&setup=true&lang=ts"
export * from "./NkSelect.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__